const BasePositionObject = function(){
    return {
        name: "",
        sight_ref_id: null,
        use_custom_email: false,
        email_subject: '',
        email_content: '',
        is_campaign: false,
        campaign_end_date: new Date()
    }
}
export default BasePositionObject

